import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { Text, Button, Toast, Icon } from 'prixa-design-kit/dist';
import { getAPI } from '../../api/api-method';
import { USER_API } from '../../api/api-url';

const imgVerificationSent = `${process.env.REACT_APP_ASSET_URL}/illustration/Email-1.png`;
const imgUnverified = `${process.env.REACT_APP_ASSET_URL}/illustration/Email-2.png`;
const imgVerified = `${process.env.REACT_APP_ASSET_URL}/illustration/Email-3.png`;

const VerificationSentPage = () => {
  const location: any = useLocation();

  return (
    <div className="prixa-container">
      <div className="prixa-question-image">
        <img loading="lazy" width="240px" alt="Prixa Verification Sent" src={imgVerificationSent} />
      </div>
      <div className="margin-baseB">
        <Text scale="heroTitle">Email verifikasi telah dikirim.</Text>
      </div>
      <div>
        <Text scale="content" style={{ fontSize: '16px' }}>
          Silakan periksa email <b>{location.state ? location.state.email : 'Anda'}</b> dan ikuti petunjuk yang
          diberikan untuk melanjutkan verifikasi.
        </Text>
      </div>
    </div>
  );
};

const VerifiedPage = () => {
  const history = useHistory();

  const goToHomePage = () => {
    history.push({
      pathname: '/continue',
      state: { option: 'Masuk' },
    });
  };

  return (
    <div className="prixa-container">
      <div className="prixa-question-image">
        <img loading="lazy" width="240px" alt="Prixa Email Verified" src={imgVerified} />
      </div>
      <div className="margin-baseB">
        <Text scale="heroTitle">Verifikasi berhasil.</Text>
      </div>
      <div>
        <Text scale="content" style={{ fontSize: '16px' }}>
          Masuk ke akun Anda untuk melanjutkan. Selamat bergabung di Prixa!
        </Text>
      </div>
      <div className="text-center margin-largeT">
        <Button onClick={() => goToHomePage()} size="xLarge" variant="primary">
          Masuk
        </Button>
      </div>
    </div>
  );
};

const UnverifiedPage = ({ email }: any) => {
  const [isErrorMsg, setError] = React.useState('');
  const [isLoad, setLoader] = React.useState(false);
  const history = useHistory();

  function resendEmail() {
    setLoader(true);
    getAPI(USER_API.RESEND_EMAIL, localStorage.getItem('loginToken') as string)
      .then(() => {
        setLoader(false);
        history.push('/verification-sent');
        localStorage.removeItem('loginToken');
        localStorage.removeItem('personID');
        localStorage.removeItem('sessionID');
      })
      .catch(err => {
        setError(err.response.data.error);
        setTimeout(() => {
          setError('');
        }, 3000);
        setLoader(false);
      });
  }

  return (
    <div className="prixa-container">
      <div className="prixa-question-image">
        <img loading="lazy" width="240px" alt="Prixa Email Unverified" src={imgUnverified} />
      </div>
      <div className="margin-baseB">
        <Text scale="heroTitle">Akun Anda belum diverifikasi.</Text>
      </div>
      <div>
        <Text scale="content" style={{ fontSize: '16px' }}>
          Silakan periksa email <b>{email ? email : 'Anda'}</b> dan ikuti petunjuk yang diberikan untuk melanjutkan
          verifikasi.
        </Text>
      </div>
      <div className="text-center margin-largeT">
        <form
          onSubmit={evt => {
            evt.preventDefault();
            resendEmail();
          }}
        >
          <Button size="xLarge" variant="primary" disabled={isLoad}>
            {!isLoad ? (
              'Kirim Ulang'
            ) : (
              <Icon className="margin-smallR" type="faCircleNotch" color="light" spin>
                Kirim Ulang
              </Icon>
            )}
          </Button>
        </form>
        <Toast timeout={3000} message={isErrorMsg} variant="danger" show={isErrorMsg !== ''}></Toast>
      </div>
    </div>
  );
};

export { VerificationSentPage, VerifiedPage, UnverifiedPage };
